// extracted by mini-css-extract-plugin
export default {"actuality":"styles_actuality__O7hBi","blue":"styles_blue__oCl-r","white":"styles_white__8NLCn"};